import { render, staticRenderFns } from "./AdminSettingsPage.vue?vue&type=template&id=5398a13c&"
import script from "./AdminSettingsPage.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports